import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c783d79a")

_pushScopeId("data-v-c783d79a")
const _hoisted_1 = { id: "scroll-icon" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("aside", _hoisted_1, [
    (_ctx.isScroll)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true)
  ]))
})